// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
export const useClasses = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        backgroundColor: tokens.colorNeutralBackground2
    },
    /* * Section for top buttons, can be used for actions like closing the chat or other controls */ topButtonsSection: {
        display: "flex",
        padding: tokens.spacingVerticalL,
        alignItems: "center",
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightSemibold
    },
    /* * Section for the chat compose area, where users can type and send messages */ chatComposeSection: {
        display: "flex",
        flex: "0 0 100px",
        alignItems: "stretch",
        width: "100%",
        padding: tokens.spacingVerticalS,
        marginTop: "auto",
        boxSizing: "border-box"
    },
    chatMessagesContainer: {
        display: "flex",
        flex: "1 1 auto",
        overflowY: "auto",
        height: 0,
        padding: tokens.spacingVerticalS,
        "& .fui-ChatMessage__body": {
            backgroundColor: tokens.colorNeutralBackground1
        }
    },
    chatContainer: {
        height: "100%",
        padding: "unset",
        overflowY: "auto"
    },
    loadingContainer: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    emptyContainer: {
        alignSelf: "center",
        width: "157px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    emptyViewImage: {
        marginBottom: tokens.spacingVerticalXXL
    },
    emptyViewText: {
        marginBottom: tokens.spacingVerticalS,
        textAlign: "center",
        fontWeight: tokens.fontWeightBold,
        fontSize: tokens.fontSizeBase400,
        color: tokens.colorNeutralForeground1
    },
    emptyViewSubText: {
        textAlign: "center",
        fontSize: tokens.fontSizeBase300,
        color: tokens.colorNeutralForeground2
    }
});
export const customVirtualListWrapperStyles = {
    // Move anchor down to trigger loading more messages earlier
    // Don't make this value much bigger than height of the chat thread, or it will could create unnecessary scroll bar when there are few messages
    anchor: {
        position: "relative",
        top: "600px"
    }
};
